"use client";

import { useRouter } from "next/navigation";
import { ComponentProps } from "react";

import { links } from "@/data/links";
import { useLang } from "@/hooks/use-lang";

type Props = ComponentProps<"tr"> & {
  symbol: string;
};
export const TableLinkRow = ({ symbol, ...props }: Props) => {
  const { lang } = useLang();
  const router = useRouter();
  return (
    <tr
      onClick={() =>
        router.push(`/${lang}${links.myAnalysisOverview({ symbol })}`)
      }
      {...props}
    >
      {props.children}
    </tr>
  );
};
